import { WISHLIST_PAGE } from "~/utils/url/staticUrls";
import { redirectToUrl } from "~/utils/url/urlUtils";
import { COPY_WISHLIST_STATUS_PARAM } from "~/features/wishlist/wishlistUrlParams";
import { occFetch, occUrl } from "~/app/api/occ/occFetch";

export function sendCopySharedWishlist({ wishlistId }: { wishlistId: string }) {
  const url = occUrl(`/copySharedWishlistManual?wishlistId=${wishlistId}`);

  return occFetch(url, { method: "POST" }).then((response) => {
    if (!response.ok) {
      const pageUrl = WISHLIST_PAGE + `?${COPY_WISHLIST_STATUS_PARAM}=false`;
      redirectToUrl(pageUrl);
    } else {
      return response.json();
    }
  });
}
